import { ComponentUtil } from '../../utils/ComponentUtil';
import { Hooks } from '../../types/Hooks';

ComponentUtil.loader(
  !!document.querySelector(Hooks.EmplyApplicationForm),
  () => import('./EmplyApplicationTracking'),
  (EmplyApplicationTracking) => {
    ComponentUtil.binder(Hooks.EmplyApplicationForm, EmplyApplicationTracking);
  },
);
